<div class="appContentsContainer">
  <form class="formGroup container halfForm">
    <div class="collapseButtonContainer">
      <div class="pageTitle collapsibleTitle" *ngIf="mastertable.type == 'D'">
        {{ "mastertablesD.titleCreate" | translate }}
      </div>
      <div class="pageTitle collapsibleTitle" *ngIf="mastertable.type == 'S'">
        {{ "mastertablesS.titleCreate" | translate }}
      </div>
    </div>
    <div class="lineGradient"></div>

    <div class="row shortRow">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel" for="peticionType">Nombre:</div>
        </div>
        <div class="inputContainer">
          <input
            type="text"
            [(ngModel)]="mastertable.name"
            name="name"
            required
          />
        </div>
        <div class="supIndexRequest">*</div>
      </div>
    </div>
    <div class="buttonsGroup">
      <div class="backButton">
        <button class="formButtonBack" type="button" (click)="goList()">
          <em class="fas fa-caret-square-left"></em>
        </button>
      </div>
      <div class="okButton">
        <div class="centerButton">
          <button class="formButtonOk" type="button" (click)="onSave()">
            {{ "commons.ok" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
